"use client";

import { useState } from "react";
import type { InlineComboboxProps } from "./inline-combobox-types";

type InlineComboboxStateOptions = Pick<
  InlineComboboxProps,
  "open" | "onOpenChange" | "searchQuery" | "onSearchChange"
>;

export function useInlineComboboxState({
  open: openProp,
  onOpenChange,
  searchQuery,
  onSearchChange,
}: InlineComboboxStateOptions) {
  const [openState, setOpenState] = useState(false);
  const [internalQuery, setInternalQuery] = useState("");
  const [highlightedValue, setHighlightedValue] = useState<string | null>(null);

  const setQuery = (next: string) => {
    setInternalQuery(next);
    onSearchChange?.(next);
    setHighlightedValue(null);
  };
  const setOpen = (next: boolean) => {
    setOpenState(next);
    onOpenChange?.(next);
    if (!next && !onSearchChange) setQuery("");
  };

  return {
    open: openProp ?? openState,
    setOpen,
    query: searchQuery ?? internalQuery,
    setQuery,
    internalQuery,
    highlightedValue,
    setHighlightedValue,
  };
}
